export default {
  GET_SMS_TEXT_BLASTS: (state) => state.smsTextBlasts,
  GET_SMS_TEXT_BLAST: (state) => state.smsTextBlast,
  GET_SMS_BLAST_UPLOAD: (state) => state.smsBlastUpload,
};
